import { EaseChatSDK, EaseChatClient } from '@/IM/initwebsdk'
import { setMessageKey, createMessage } from '@/utils/handleSomeData'
import { sendMsg, revocationMsg } from '@/api/custom'
import _ from 'lodash'
// import { ref, toRaw } from 'vue';
import { messageType } from '@/constant'
import { usePlayRing } from '@/hooks'
import Groups from './goups'
const { ALL_MESSAGE_TYPE } = messageType

const Message = {
  state: {
    messageList: {},
    currentChatId: '', //当前会话的对方环信id
    newMessageSessionKey: '',
  },
  mutations: {
    UPDATE_NEW_MESSAGE_SESSION_KEY: (state, key) => {
      state.newMessageSessionKey = key
    },
    // 更改当前会话id
    UPDATE_CURRENT_CHAT_ID(state, chatId) {
      state.currentChatId = chatId
    },
    UPDATE_MESSAGE_LIST: (state, msgBody) => {
      const toUpdateMsgList = _.assign({}, state.messageList)
      const listKey = setMessageKey(msgBody)
      if (!toUpdateMsgList[listKey]) {
        toUpdateMsgList[listKey] = []
        _.unionBy(toUpdateMsgList[listKey].push(msgBody), (m) => m.id)
      } else {
        _.unionBy(toUpdateMsgList[listKey].push(msgBody), (m) => m.id)
      }
      state.messageList = toUpdateMsgList
    },
    UPDATE_HISTORY_MESSAGE: (state, payload) => {
      const { listKey, historyMessage } = payload
      const toUpdateMsgList = _.assign({}, state.messageList)
      if (!toUpdateMsgList[listKey]) {
        toUpdateMsgList[listKey] = []
        _.unionBy(toUpdateMsgList[listKey].push(...historyMessage), (m) => m.id)
      } else {
        // historyMessage
        console.log('%c Line:36 🥪 获取到的历史消息 historyMessage', 'color:#b03734', historyMessage)
        if (toUpdateMsgList[listKey][0].id !== historyMessage[0].id) {
          _.unionBy(toUpdateMsgList[listKey].unshift(...historyMessage), (m) => m.id)
        }
      }
      state.messageList = toUpdateMsgList
    },
    //清除某条会话消息
    CLEAR_SOMEONE_MESSAGE: (state, payload) => {
      state.messageList[payload] = []
    },
    //撤回删除消息
    CHANGE_MESSAGE_BODAY: (state, payload) => {
      const { type, key, mid } = payload
      if (type === 'recall') {
        if (state.messageList[key]) {
          const res = _.find(state.messageList[key], (o) => o.id === mid)
          res.isRecall = true
        }
      }
      if (type === 'deleteMsg') {
        if (state.messageList[key]) {
          const sourceData = state.messageList[key]
          const index = _.findIndex(state.messageList[key], (o) => o.id === mid)
          sourceData.splice(index, 1)
          state.messageList[key] = _.assign([], sourceData)
        }
      }
    },
  },
  actions: {
    //添加新消息
    createNewMessage: ({ dispatch, commit }, params) => {
      console.log('%c Line:79 🌰新消息>>>>>>> params', 'color:#33a5ff', params)
      const { isOpenPlayRing, playRing } = usePlayRing()
      const key = setMessageKey(params)
      // const chatTypeInfo = localStorage.getItem('chatTypeInfo') || 1
      // console.log('chatTypeInfo', chatTypeInfo)

      commit('UPDATE_MESSAGE_LIST', params)
      //目前根据全局配置进行新消息声音提示，后续计划根据会话级别可进行设置是否声音提示，比如设定免打扰。
      if (isOpenPlayRing.value) {
        const loginUserId = EaseChatClient.user
        if (loginUserId != params.from) {
          playRing()
          // if (chatTypeInfo == 1) {
          //     if (
          //         params.type == 'txt' &&
          //         params.msg &&
          //         params.msg.indexOf('@') > -1
          //     ) {
          //         if (
          //             window.Notification &&
          //             Notification.permission !== 'denied'
          //         ) {
          //             Notification.requestPermission(function (
          //                 status
          //             ) {
          //                 var n = new Notification('您有新消息', {
          //                     body: '新消息：' + params.msg
          //                 })
          //             })
          //         }
          //     }
          // } else if (chatTypeInfo == 2) {
          //     if (
          //         params.type == 'txt' &&
          //         params.msg &&
          //         params.msg.indexOf('@') > -1 &&
          //         params.chatType == 'singleChat'
          //     ) {
          //         if (
          //             window.Notification &&
          //             Notification.permission !== 'denied'
          //         ) {
          //             Notification.requestPermission(function (
          //                 status
          //             ) {
          //                 var n = new Notification('您有新消息', {
          //                     body: '新消息：' + params.msg
          //                 })
          //             })
          //         }
          //     }
          // } else if (chatTypeInfo == 3) {
          //     if (
          //         params.type == 'txt' &&
          //         params.msg &&
          //         params.msg.indexOf('@') > -1 &&
          //         params.chatType == 'groupChat'
          //     ) {
          //         if (
          //             window.Notification &&
          //             Notification.permission !== 'denied'
          //         ) {
          //             Notification.requestPermission(function (
          //                 status
          //             ) {
          //                 var n = new Notification('您有新消息', {
          //                     body: '新消息：' + params.msg
          //                 })
          //             })
          //         }
          //     }
          // }
          if (params.type == 'txt' && params.msg && params.msg.indexOf('@') > -1) {
            if (window.Notification && Notification.permission !== 'denied') {
              Notification.requestPermission(function (status) {
                var n = new Notification('您有新消息', {
                  body: '新消息：' + params.msg,
                })
              })
            }
          }
        }
      }
      dispatch('gatherConversation', key)
    },
    //获取历史消息
    getHistoryMessage: async ({ dispatch, commit }, params) => {
      const { id, chatType, cursor } = params
      console.log('%c Line:84 🌽获取历史消息 params', 'color:#f5ce50', params)
      return new Promise((resolve, reject) => {
        const options = {
          targetId: id,
          pageSize: 10,
          cursor: cursor,
          chatType: chatType,
          searchDirection: 'up',
        }
        EaseChatClient.getHistoryMessages(options)
          .then((res) => {
            const { cursor, messages } = res
            messages.length > 0 &&
              messages.forEach((item) => {
                item.read = true
              })
            resolve({ messages, cursor })
            commit('UPDATE_HISTORY_MESSAGE', {
              listKey: id,
              historyMessage: _.reverse(messages),
            })
            //提示会话列表更新
            dispatch('gatherConversation', id)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    //发送展示类型消息
    sendShowTypeMessage: async ({ dispatch, commit, state, rootState }, params) => {
      return new Promise((resolve, reject) => {
        //console.log('%c Line:126 🍖 params', 'color:#ed9ec7', params)
        //主要作用为创建消息Options中附件会有上传失败的回调函数。
        //传入errorCallback，让附件类型消息在上传失败时调用reject抛出error

        // params
        let params2 = {}
        let msgData = {}
        if (params.msgType == 'txt') {
          if (params.msgOptions.msg && /^订单编号/.test(params.msgOptions.msg)) {
            // 发送的是订单
            msgData = {
              fromUser: EaseChatClient.user,
              content: params.msgOptions.msg,
              senType: 'order',
            }
            params.msgOptions.customExts = params.msgOptions.msg
            params.msgOptions.customEvent = msgData.senType
            params = {
              msgType: 'custom',
              msgOptions: params.msgOptions,
            }
          } else {
            // 普通文本
            msgData = {
              fromUser: EaseChatClient.user,
              content: params.msgOptions.msg,
              senType: 'text',
            }
          }
        } else if (params.msgType == 'img') {
          msgData = {
            fromUser: EaseChatClient.user,
            content: params.msgOptions.imgUrl,
            senType: 'image',
          }
        } else if (params.msgType == 'audio') {
          let content = {
            url: params.msgOptions.file.url,
            length: params.msgOptions.length,
          }
          msgData = {
            fromUser: EaseChatClient.user,
            content: JSON.stringify(content),
            senType: 'audio',
          }
        } else if (params.msgType == 'video') {
          msgData = {
            fromUser: EaseChatClient.user,
            content: params.msgOptions.url,
            senType: 'video',
          }
          params.msgOptions.customExts = params.msgOptions.url
          params.msgOptions.customEvent = msgData.senType
          params = {
            msgType: 'custom',
            msgOptions: params.msgOptions,
          }
        } else if (params.msgType == 'goods') {
          msgData = {
            fromUser: EaseChatClient.user,
            content: params.msgOptions.goods,
            senType: 'goods',
          }
          params.msgOptions.customExts = params.msgOptions.goods
          params.msgOptions.customEvent = msgData.senType
          params = {
            msgType: 'custom',
            msgOptions: params.msgOptions,
          }
        } else {
          msgData = {
            fromUser: EaseChatClient.user,
            content: params.msgOptions.content,
            senType: params.msgType,
          }
          params.msgOptions.customExts = params.msgOptions.content
          params.msgOptions.customEvent = msgData.senType
          params = {
            msgType: 'custom',
            msgOptions: params.msgOptions,
          }
        }
        if (params.msgOptions.chatType == 'groupChat') {
          // 群聊
          msgData.toGroup = params.msgOptions.id
          // state
          //console.log("%c Line:211 🥝 Groups", "color:#e41a6a", Groups.state.groupsInfos);
          // if(Groups.state.groupsInfos[params.msgOptions.id]){
          //   let persons = Groups.state.groupsInfos[params.msgOptions.id]
          // }
        } else if (params.msgOptions.chatType == 'singleChat') {
          // 单聊
          msgData.toUser = params.msgOptions.id
        }

        const errorCallback = (error) => {
          reject(error)
        }

        const options = createMessage.createOptions(params, errorCallback)
        const msg = EaseChatSDK.message.create(options)
        // state.messageExt
        const msgExt = {
          fromUserInfo: {
            avatar: rootState.loginUserInfo.avatarurl,
            nickName: rootState.loginUserInfo.nickname,
          },
        }
        if (state.messageExt) {
          try {
            const obj = JSON.parse(state.messageExt)
            Object.assign(msgExt, obj)
          } catch (e) {}
        }
        msgData.ext = JSON.stringify(msgExt)

        sendMsg(msgData)
          .then((res) => {
            console.log('msgData', msgData)

            // commit('UPDATE_messageExt', '')
            //console.log('%c Line:138 🍋 res', 'color:#93c0a4', res)
            if (res.code == 200) {
              // if (params.msgType == 'b_backlist'||params.msgType == 'b_backorder'){
              // }else{
              const msgIdMap = res.data.msgIdMap
              msg.id = msgIdMap[params.msgOptions.id]
              msg.from = EaseChatClient.user
              const msgBody = createMessage.createMsgBody(msg)
              msgBody.type = msgData.senType == 'text' ? 'txt' : 'custom'
              msgBody.customEvent = msgData.senType == 'text' ? '' : msgData.senType
              if (msgData.senType != 'text') {
                msgBody.customExts = {
                  content: msgData.content,
                }
              }
              if (msgData.toUser) {
                commit('UPDATE_MESSAGE_LIST', msgBody)
              }
              // 提示会话列表更新
              dispatch('gatherConversation', msgBody.to)
              // 将消息存到本地未读消息列表 只存单聊的
              if (params.msgOptions.chatType == 'singleChat') dispatch('addMsgToUnreadIds', msg.id)
              // }
              commit('SET_INPUT_QUICK_WORD', '')

              resolve('OK')
            } else {
              ElMessage.error(res.msg)
            }
          })
          .catch((err) => {
            let obj = {
              type: 'error',
              message: err.msg,
            }
            reject(obj)
          })
        // EaseChatClient.send(msg)
        //     .then((res) => {
        //         const { serverMsgId } = res
        //         //console.log('>>>>发送成功demo', res)
        //         msg.id = serverMsgId
        //         msg.from = EaseChatClient.user
        //         const msgBody = createMessage.createMsgBody(msg)
        //         commit('UPDATE_MESSAGE_LIST', msgBody)
        //         // 提示会话列表更新
        //         dispatch('gatherConversation', msgBody.to)
        //         resolve('OK')
        //     })
        //     .catch((error) => {
        //         reject(error)
        //     })
      })
    },
    //添加通知类消息
    createInformMessage: ({ dispatch, commit }, params) => {
      /** 
               const params = {
                    from: '',
                    to: '',
                    chatType: '',
                    msg:''
                }
            */
      const msgBody = _.cloneDeep(params)
      msgBody.type = ALL_MESSAGE_TYPE.INFORM
      const key = setMessageKey(params)
      console.log('>>>>>>添加系统消息', params)
      commit('UPDATE_MESSAGE_LIST', msgBody)
      dispatch('gatherConversation', key)
    },
    //撤回消息
    recallMessage: async ({ dispatch, commit }, params) => {
      const { mid, to, chatType } = params
      return new Promise((resolve, reject) => {
        EaseChatClient.recallMessage({ mid, to, chatType })
          .then(() => {
            let sessionId = ''
            if (chatType == 'groupChat') {
              sessionId = to
            } else {
              const loginUserId = EaseChatClient.user
              if (loginUserId > to) {
                sessionId = loginUserId + to
              } else {
                sessionId = to + loginUserId
              }
            }
            revocationMsg({ messageId: mid, sessionId })
            commit('CHANGE_MESSAGE_BODAY', {
              type: 'recall',
              key: to,
              mid,
            })
            dispatch('gatherConversation', to)
            resolve('OK')
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
  },
}
export default Message
